import { gql } from "@apollo/client";

import { clip_client_projectable_data } from "../../fragments";

export const fetchDemonstrationClips = gql`
  ${clip_client_projectable_data}
  query fetch_demonstration_clips(
    $allowed_podcast_channel_ids: _int4!
    $maximum_duration: Int
    $minimum_duration: Int
  ) {
    get_clips_of_recent_episodes(
      args: {
        allowed_podcast_channel_ids: $allowed_podcast_channel_ids
        number_of_recent_episodes: 10
        maximum_duration: $maximum_duration
        minimum_duration: $minimum_duration
      }
    ) {
      ...clip_client_projectable_data
    }
  }
`;
